export enum GraphqlErrorTypes {
  BAD_REQUEST = '400: Bad Request',
  NOT_FOUND = '404: Not Found',
  SESSION_EXPIRED = 'Session expired'
}

export enum SsoUserRole {
  USER = 'USER',
  CUSTOMER = 'CUSTOMER',
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  EVOUCHER_BACKOFFICE_USER = 'EVOUCHER_BACKOFFICE_USER'
}
